
<template>
  <div>
    <p class="text" v-if="type !== fieldType.ATTACHMENTS">
      {{ title }}
      <span v-if="required" class="required">*</span>
    </p>
    <template v-if="type == fieldType.PLAINTEXT">
      <input
        :class="sizeField[height]" type="text" class="input" v-model="content" @change="this.$emit('updateValue', value)"/>
    </template>
    <template v-else-if="type == fieldType.RICHTEXT_TOOLBAR">
      <div class="toolbar" :id="'toolbar-container-' + id" />
      <tiny-editor
        :class="sizeField[height]"
        class="input textarea"
        :toolbar-container="'toolbar-container-' + id"
        :text.sync="content"
      />
    </template>
    <add-attachment-field v-else-if="type === fieldType.ATTACHMENTS"
      :title="title" :required="required" :uploadedAttachmentFile="uploadedAttachmentFile" :addedAttachments="value" :fieldKey="fieldKey"
      @openUppy="openUppy" @addAttachment="addAttachment" @deleteAttachment="deleteAttachment"/>
    <template v-else-if="type == fieldType.AUTOCOMPLETE">
      <v-select
        taggable
        v-model="selectedAutocomplete"
        :options="autocompleteValuesArr"
        :value="selectedAutocomplete"
        :clearable="false"
        @input="setSelectedAutocomplete"
        data-test="autocompleteValuesArr"
      >
      <span slot="no-options"></span>
      </v-select>
    </template>
    <template v-else-if="type === fieldType.SELECT || type === fieldType.SELECT_MULTIPLE">
      <v-select
        taggable
        v-model="selectFeildSelection"
        :multiple="type === fieldType.SELECT_MULTIPLE"
        :options="selectionOptions"
        :clearable="true"
        @input="setSelection"
      >
      </v-select>
    </template>
    <span class="error-text">{{ $t("ERROR_TEXT") }}</span>
  </div>
</template>

<script>
import TinyEditor from '@/components/tiny-editor'
import vSelect from 'vue-select'
import { sizeField, fieldType } from '@/constants'
import addAttachmentField from '@/components/add-attachment-field'

export default {
  name: 'fields',

  components: { TinyEditor, vSelect, addAttachmentField },

  props: {
    type: {
      type: String,
      default: 'RICHTEXT_TOOLBAR'
    },
    value: {
      type: [String, Array],
      default: null
    },
    height: {
      type: String,
      default: sizeField.SMALL
    },
    required: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true,
      default: ''
    },
    uploadedAttachmentFile: {
      type: String,
      required: false,
      default: null
    },
    selectionOptions: {
      type: Array,
      required: false,
      default: () => []
    },
    fieldKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      sizeField,
      fieldType,
      selectedAutocomplete: null,
      selectFeildSelection: null,
      autocompleteValuesArr: []
    }
  },
  computed: {
    content: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('update:text', value)
        this.$emit('setDynamicField', value)
      }
    }
  },

  mounted () {
    if (this.type === this.fieldType.AUTOCOMPLETE) {
      this.getAutoCompleteValues()
    }
  },

  watch: {
    value () {
      if (this.value) {
        if (this.type === fieldType.AUTOCOMPLETE) {
          this.selectedAutocomplete = this.value
        } else if (this.type === fieldType.SELECT_MULTIPLE || this.type === fieldType.SELECT) {
          this.selectFeildSelection = this.value
        }
      }
    }
  },
  methods: {
    setSelectedAutocomplete () {
      if (this.selectedAutocomplete.trim().length === 0) {
        this.selectedAutocomplete = null
      }
      this.$emit('setDynamicField', this.selectedAutocomplete)
    },
    setSelection () {
      this.$emit('setDynamicField', this.selectFeildSelection)
    },
    // return a list of all the values that are available for an autocomplete field
    async getAutoCompleteValues () {
      this.autocompleteValuesArr = await this.$store.dispatch('getAutoCompleteValues', this.fieldKey)
    },
    openUppy (type) {
      this.$emit('openUppy', type)
    },
    addAttachment (data) {
      this.$emit('addAttachment', data)
    },
    deleteAttachment (index) {
      this.$emit('deleteAttachment', index)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/styles/cssComponents/variables/variables";
@import "src/assets/styles/cssComponents/mainComponents/mixins";
.textarea{
  $height: 74px;
  @include scrollbar();
  &.small{height: $height;}
  &.medium{height: calc(#{$height} * 1.8);}
  &.large{height: calc(#{$height}  * 3.2);}
}
.v-text-field.v-text-field--solo .v-input__control{
    min-height: 10px;
}
.v-label{
  font-size: 10px;
}
</style>
